<template>
    <section class="test-drive">
        <div class="thank-you__container container">
            <div class="test-drive__content">
                <div class="thank-you__main">
                    <h2 class="title">
                        Thanks for your <span class="capitalise">{{ model.model_title }}</span> test drive request
                    </h2>

                    <!-- Only to be displayed on mobile -->
                    <div class="thank-you__info-mobile">
                        <picture v-if="model.image">
                            <source v-if="model.image_webp" :srcset="model.image_webp" type="image/webp" />
                            <img class="img-responsive thank-you__image" :src="model.image" :alt="model.model_title" />
                        </picture>

                        <div class="thank-you__details">
                            <h3 class="capitalise">{{ model.model_title }}</h3>
                            <p class="extras">
                                <span>Engine:</span> {{ fuelChoice }} <br />
                                <span>Transmission:</span> {{ transmissionChoice.toLowerCase() }}
                            </p>

                            <p v-if="notes !== ''">
                                <span>Notes:</span> <br />
                                {{ notes }}
                            </p>
                        </div>
                    </div>
                    <!-- Only to be displayed on mobile -->

                    <p class="description">
                        A member of the team will be in contact shortly to confirm your appointment. The vehicle you test drive will be dependant on availability but every effort will be made to meet your preferred selections. We hope you enjoy your {{ model.model_title }} test drive.
                    </p>

                    <div class="card">
                        <div class="card__inner">
                            <div class="thank-you__details-container">
                                <div class="thank-you__booking-details">
                                    <h3 class="thank-you__title">Booking Details</h3>
                                    <p class="thank-you__body">
                                        <strong>Date:</strong> {{ date }} <br />
                                        <strong>Time:</strong> {{ time }}
                                    </p>
                                </div>

                                <div class="thank-you__dealer-details">
                                    <h3 class="thank-you__title">Dealer Address</h3>
                                    <p class="thank-you__body">
                                        {{ dealer.name }} <br />
                                        {{ dealer.address }} <br />
                                        {{ dealer.postcode }}
                                    </p>
                                    <a :href="directionsLink" class="link link--has-icon" target="_blank" rel="noopener">Get directions</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="thank-you__button-container">
                        <a class="btn btn--primary" :href="`/${brand}/new/${model.url_model}`">Find out more</a>
                        <a class="btn btn--primary" href="/car-valuation">Value my car</a>
                    </div>
                </div>

                <!-- Only to be displayed on desktop -->
                <div class="thank-you__info-desktop">
                    <picture v-if="model.image">
                        <source v-if="model.image_webp" :srcset="model.image_webp" type="image/webp" />
                        <img class="img-responsive thank-you__image" :src="model.image" :alt="model.model_title" />
                    </picture>

                    <div class="thank-you__details">
                        <h3 class="capitalise">{{ model.model_title }}</h3>
                        <p class="extras">
                            <span>Engine:</span> {{ fuelChoice }} <br />
                            <span>Transmission:</span> {{ transmissionChoice.toLowerCase() }}
                        </p>

                        <p v-if="notes !== ''">
                            <span>Notes:</span> <br />
                            {{ notes }}
                        </p>
                    </div>
                </div>
                <!-- Only to be displayed on desktop -->
            </div>
        </div>
    </section>
</template>

<script>
import { mapState } from "vuex";
import EventObject from "../../modules/tracking/EventObject";

export default {
    props: {
        brand: {
            required: true,
        },
        urlModel: {
            required: true,
        },
    },
    created() {
        if (!this.haveMinimumModelData) {
            this.$router.push({ name: 'select-options', params: {brand: brand, urlModel: this.urlModel}});
            return;
        }
        if (!this.haveMinimumDealerData) {
            this.$router.push({ name: 'select-dealer', params: {brand: brand, urlModel: this.urlModel}});
            return;
        }
        if (!this.haveMinimumTimeData) {
            this.$router.push({ name: 'select-time', params: {brand: brand, urlModel: this.urlModel}});
            return;
        }
        if (!this.haveMinimumCustomerData) {
            this.$router.push({ name: 'your-details', params: {brand: brand, urlModel: this.urlModel}});
            return;
        }
    },
    mounted() {
        if (this.thankYouPage === true) {
            new EventObject("New Car - Test Drive Form", "Revisit", "Thank You Page").dispatch();
        } else {
            new EventObject("New Car - Test Drive Form", "Visited", "Thank You Page").dispatch();
            this.$store.commit("setThankYouPage", true);
        }
    },
    computed: {
        ...mapState(["model", "fuelChoice", "transmissionChoice", "notes", "dealer", "date", "time", "thankYouPage", "directionsLink"]),
        ...mapState("CustomerDate", ["email"]),
        haveMinimumModelData() {
            if (this.fuelChoice == '') {
                return false;
            }
            if (this.transmissionChoice == '') {
                return false;
            }
            return true;
        },

        haveMinimumDealerData() {
            if (this.dealer.length == 0) {
                return false;
            }
            return true;
        },

        haveMinimumTimeData() {
            if (this.date == '') {
                return false;
            }
            if (this.time == '') {
                return false;
            }
            return true;
        },

        haveMinimumCustomerData() {
            if (this.email == '') {
                return false;
            }
            return true;
        },
    },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/test-drive/pages/thank-you.vue